import { messageLog } from 'utilities/helpers/logger/message-logger.js';

export type FetchDataReturnOK<T> = { responseOK: true; jsonData: T; url: string };
type FetchDataReturnBad = { responseOK: false; err: string; url: string };

type FetchDataProps<T> = {
  url: string;
  signal?: AbortSignal | undefined;
  goodCB?: (p: FetchDataReturnOK<T>) => void;
  badCB?: (p: FetchDataReturnBad) => void;
};

export type FetchDataReturn<T> = FetchDataReturnOK<T> | FetchDataReturnBad;

/** Used as part of react query to normalise query result */
export const fetchAsyncData = async <T,>({
  url,
  signal,
  badCB,
  goodCB,
}: FetchDataProps<T>): Promise<FetchDataReturn<T>> => {
  try {
    const request = await fetch(url, { credentials: 'include', signal });
    if (request.ok) {
      const jsonData = await request.json();
      const goodResult: FetchDataReturnOK<T> = { responseOK: true, jsonData, url };
      goodCB?.(goodResult);
      return goodResult;
    } else {
      const badResult: FetchDataReturnBad = { responseOK: false, err: `${request.status}: ${request.statusText}`, url };
      badCB?.(badResult);
      return badResult;
    }
  } catch (error) {
    let message = 'Unknown Error';
    if (error instanceof Error) {
      message = error.message;
    }
    messageLog.info(`Failed fetch dataUrl ${url}`, ['err', error]);
    const badResult: FetchDataReturnBad = { responseOK: false, err: message, url };
    badCB?.(badResult);
    return badResult;
  }
};
